import React ,{Fragment}from 'react';
import {Button} from "antd";
import {
  WeaDialogFooter,
  WeaLocaleProvider,
} from 'ecCom';
import '../style/weakPassConfirm.less';
const getLabel = WeaLocaleProvider.getLabel;

export default function WeakPassConfirm(){
	const handleCondirm = () => {
		const dialog = top.window.getParentDialog();
		dialog.close();
		dialog.callback();
	}
	return (
		<Fragment ecId={`${this && this.props && this.props.ecId || ''}_Fragment@bsnn60`}>
			<div className="hrm-weak-pass">
				<p>
	    	       {getLabel('516219','该密码安全性较低，管理员已开启弱密码禁止保存设置，请修改密码。') }
	    	    </p>
        	</div>
	    	<WeaDialogFooter ecId={`${this && this.props && this.props.ecId || ''}_WeaDialogFooter@q6a5o6`} buttons={<Button ecId={`${this && this.props && this.props.ecId || ''}_Button@qrg968`} type="primary" onClick={handleCondirm}>{getLabel(33703, '确定')}</Button>}/>
		</Fragment>
	)
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/WeakPassConfirm.js